import { Link } from 'react-router-dom';
import { useOutreachReadiness } from './useOutreachReadiness';
import campStyles from './Campaigns.module.css';

export function CampaignReadinessPanel({
  projectId,
  sendRail = 'smtp',
}: {
  projectId: string;
  sendRail?: 'smtp' | 'brevo_transactional';
}) {
  const q = useOutreachReadiness(projectId, sendRail);

  if (q.isLoading) {
    return (
      <section className={campStyles.panel}>
        <div className={campStyles.panelHead}>
          <h2 className={campStyles.panelTitle}>Outreach readiness</h2>
        </div>
        <p className={campStyles.panelBodyMuted}>Controleren…</p>
      </section>
    );
  }
  if (q.isError) return null;

  const r = q.data?.readiness;
  if (!r) return null;

  return (
    <section className={campStyles.panel}>
      <div className={campStyles.panelHead}>
        <h2 className={campStyles.panelTitle}>Outreach readiness</h2>
        <span className={r.ready ? campStyles.readinessOk : campStyles.readinessFail}>
          {r.ready ? 'Gereed' : 'Actie vereist'}
        </span>
      </div>
      <div className={campStyles.panelBody}>
        <p className={campStyles.panelBodyMuted} style={{ padding: 0 }}>
          {r.ready
            ? 'Automatische checks zijn OK — je kunt sequence-campagnes starten (binnen limieten).'
            : 'Los onderstaande punten op vóór je een campagne start.'}
        </p>
        <ul className={campStyles.readinessList}>
          {r.checks.map((c) => (
            <li key={c.id} className={campStyles.readinessItem}>
              <span className={c.ok ? campStyles.readinessIconOk : campStyles.readinessIconPending}>
                {c.ok ? '✓' : '○'}
              </span>
              <span>{c.message}</span>
            </li>
          ))}
        </ul>
        <p className={campStyles.panelBodyMuted} style={{ padding: 0 }}>
          SPF/DKIM/DMARC:{' '}
          <Link to="/app/deliverability">Deliverability-checklist</Link>
        </p>
      </div>
    </section>
  );
}
